import { Endpoint } from '../endpoint';
import { GraphDailyQuotaResponse, GraphResponse } from '@business/entities/graph';
import { GraphQuotaFormData } from '@modules/statistics/graphs/AddEditDailyQuotaGraphModal/AddEditDailyQuotaGraphModal';

export function createDailyQuota(data: GraphQuotaFormData) {
  return Endpoint.post<GraphResponse>(`@makh/graph-daily-quota`, { data });
}

export function updateDailyQuota(id: string, data: GraphQuotaFormData) {
  return Endpoint.patch<GraphResponse>(`@makh/graph-daily-quota/${id}`, { data });
}

export function fetchDailyQuota(id: string, week: number, year: number) {
  return Endpoint.get<GraphDailyQuotaResponse>(`@makh/graph-daily-quota/${id}`, { params: { week, year } });
}
